import { render, staticRenderFns } from "./MainCanvas.vue?vue&type=template&id=13914ac3&scoped=true"
import script from "./MainCanvas.vue?vue&type=script&lang=js"
export * from "./MainCanvas.vue?vue&type=script&lang=js"
import style0 from "./MainCanvas.vue?vue&type=style&index=0&id=13914ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13914ac3",
  null
  
)

export default component.exports